import { render, staticRenderFns } from "./ResultIpinAuthTpsPop.vue?vue&type=template&id=9ebb2cf0&scoped=true&"
import script from "./ResultIpinAuthTpsPop.vue?vue&type=script&lang=js&"
export * from "./ResultIpinAuthTpsPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebb2cf0",
  null
  
)

export default component.exports